module.exports = __webpack_public_path__ + "img/24.44dd5839.jpg";